export default __webpack_public_path__ + "static/media/instagram-icon.ad2e207e.svg";